(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["best-sellers"] && !Shopify.designMode) return;
  try {
    
  class BestSellersTabs extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.tabs = this.querySelectorAll('.best-sellers__tab');
      this.sliders = this.querySelectorAll('.best-sellers__slider');

      this.tabs.forEach((tab, index) => {
        tab.addEventListener('click', () => {
          this.switchTab(index);
        });
      });
    }

    switchTab(index) {
      this.tabs.forEach(tab => tab.classList.remove('is-active'));
      this.sliders.forEach(slider => slider.classList.remove('is-active'));

      this.tabs[index].classList.add('is-active');
      this.sliders[index].classList.add('is-active');
    }
  }

  customElements.define('best-sellers-tabs', BestSellersTabs);


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection-banner"] && !Shopify.designMode) return;
  try {
    
class CollectionDescription extends HTMLElement {
  constructor() {
    super();
    this.charLimit = 150;
  }

  connectedCallback() {
    const fullText = this.textContent.trim();
    if (!fullText || fullText.length <= this.charLimit) return;

    this.fullText = fullText;
    this.truncatedText = fullText.slice(0, this.charLimit).trim() + "...";

    this.renderTruncated();

    this.addEventListener("click", (e) => {
      if (!e.target.classList.contains("read-toggle")) return;

      if (this.classList.contains("is-expanded")) {
        this.renderTruncated();
      } else {
        this.renderFull();
      }
    });
  }

  renderTruncated() {
    this.innerHTML = `${this.truncatedText} <span class="read-toggle"> Read more</span>`;
    this.classList.remove("is-expanded");
  }

  renderFull() {
    this.innerHTML = `${this.fullText} <span class="read-toggle"> Show less</span>`;
    this.classList.add("is-expanded");
  }
}

customElements.define('collection-description', CollectionDescription);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-description"] && !Shopify.designMode) return;
  try {
    
  const slider = document.querySelector('.product-description__gallery');

  let isDown = false;
  let startX;
  let scrollLeft;
  let velocity = 0;
  let lastX;
  let raf;

  slider.addEventListener('mousedown', (e) => {
    isDown = true;
    slider.classList.add('dragging');

    startX = e.pageX;
    lastX = e.pageX;
    scrollLeft = slider.scrollLeft;
    velocity = 0;

    cancelAnimationFrame(raf);
  });

  slider.addEventListener('mouseup', () => {
    isDown = false;
    momentum();
  });

  slider.addEventListener('mouseleave', () => {
    if (!isDown) return;
    isDown = false;
    momentum();
  });

  slider.addEventListener('mousemove', (e) => {
    if (!isDown) return;
    e.preventDefault();

    const dx = e.pageX - startX;
    slider.scrollLeft = scrollLeft - dx;

    velocity = e.pageX - lastX;
    lastX = e.pageX;
  });

  function momentum() {
    velocity *= 0.95;

    slider.scrollLeft -= velocity;

    if (Math.abs(velocity) > 0.5) {
      raf = requestAnimationFrame(momentum);
    }
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sticky-atc"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('sticky-atc')) {
  class StickyATC extends HTMLElement {
    constructor() {
      super();

      this.onScroll = this.onScroll.bind(this);
      this.onVariantUpdate = this.onVariantUpdate.bind(this);
    }

    connectedCallback() {
      this.addEventListenerOnce();
      this.cacheElements();
      this.calculateThreshold();

      window.addEventListener('scroll', this.onScroll);

      document.addEventListener(
        'variant:update',
        this.onVariantUpdate
      );
    }

    disconnectedCallback() {
      window.removeEventListener('scroll', this.onScroll);

      document.removeEventListener(
        ThemeEvents.variantUpdate,
        this.onVariantUpdate
      );
    }

    addEventListenerOnce() {
      if (this.initialized) return;
      this.initialized = true;
    }

    cacheElements() {
      this.img = this.querySelector('.product-content img');
      this.selectField = this.querySelector('select[name="id"]');
      this.quantityInput = this.querySelector('.quantity__input');
    }

    calculateThreshold() {
      const addBtn = document.querySelector('button[name="add"]');

      this.threshold = addBtn
        ? addBtn.getBoundingClientRect().bottom + window.scrollY
        : 0;
    }

    onScroll() {
      if (window.scrollY > this.threshold) {
        this.classList.add('show');
        document.documentElement.style.paddingBottom =
          `${this.clientHeight}px`;
      } else {
        this.classList.remove('show');
        document.documentElement.style.paddingBottom = '0';
      }
    }

    onVariantUpdate(event) {
      const { html } = event.detail.data || {};

      if (!html) return;

      const newSticky = html.querySelector('#md-sticky-atc');

      if (!newSticky) return;

      this.innerHTML = newSticky.innerHTML;

      this.cacheElements();
    }
  }

  customElements.define('sticky-atc', StickyATC);
}

  } catch(e) { console.error(e); }
})();
})();
